import React, { useEffect, useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { X } from "lucide-react";
import {
  CloseButton,
  ErrorMessage,
  ModalContent,
  TourIframe,
} from "./styles";

export const IFRAME_LOAD_ERROR_MESSAGE =
  "Não foi possível carregar o tour virtual. Tente novamente mais tarde.";

type VirtualTourModalProps = {
  url: string;
  isOpen: boolean;
  onClose: () => void;
};

function VirtualTourModal({ url, isOpen, onClose }: VirtualTourModalProps) {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setHasError(false);
    }
  }, [isOpen, url]);

  function handleIframeError() {
    setHasError(true);
  }

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      closeOnEsc
      showCloseIcon={false}
      styles={{
        modal: {
          width: "100vw",
          maxWidth: "100vw",
          height: "100vh",
          maxHeight: "100vh",
          margin: 0,
          padding: 0,
          borderRadius: 0,
          background: "transparent",
          boxShadow: "none",
        },
        modalContainer: {
          padding: 0,
        },
        overlay: {
          background: "rgba(0, 0, 0, 0.85)",
          padding: 0,
        },
      }}
    >
      <ModalContent>
        <CloseButton
          type="button"
          aria-label="Fechar tour virtual"
          onClick={onClose}
        >
          <X />
        </CloseButton>

        {hasError ? (
          <ErrorMessage>{IFRAME_LOAD_ERROR_MESSAGE}</ErrorMessage>
        ) : (
          <TourIframe
            src={url}
            title="Tour virtual"
            allow="xr-spatial-tracking; fullscreen"
            onError={handleIframeError}
          />
        )}
      </ModalContent>
    </Modal>
  );
}

export default VirtualTourModal;
